import {
	FormItem,
	TextInput,
	TextInputHandle,
	ValidationError
} from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { localize } from "client_legacy/ndaw/culture";
import { SharedSpaceFormData } from "./EditSpaceDialog";
import {
	ReactElement,
	Ref,
	RefObject,
	useImperativeHandle,
	useRef
} from "react";
import styles from "./General.module.less";

export type GeneralHandle = {
	focusFirstInput: () => void;
};

export type GeneralProps = {
	attachable: IValueInputAttachable<SharedSpaceFormData>;
	ref?: Ref<GeneralHandle>;
};

export const General = (props: GeneralProps): ReactElement => {
	const {
		attachable,
		ref
	} = props;

	const nameRef: RefObject<TextInputHandle | null> = useRef<TextInputHandle>(null);

	useImperativeHandle(
		ref,
		(): GeneralHandle => ({
			focusFirstInput: () => {
				nameRef?.current
					?.focus();
			}
		}),
		[]
	);

	return (
		<div className={styles.root}>
			<FormItem
				label={localize("_Name")}
				isRequired
			>
				<TextInput
					{...attachable.for("name").attachToTextInput()}
					ref={nameRef}
				/>

				<ValidationError {...attachable.for("name").attachToValidationError()} />
			</FormItem>
		</div>
	);
};
General.displayName = "General";
